$(document).ready(function(){
   var getval = $("select[name='currency_code'] option:selected").attr('getsymbol');
  $(".get-currncy-symbol").text(getval);
  
  $("select[name='currency_code']").on("change", function() {
 var getval = $(this).find('option:selected').attr('getsymbol'); 
   $(".get-currncy-symbol").text(getval);
});
  function updateCurrencySymbol() {
  var getval = $("select[name='currency_code'] option:selected").attr('getsymbol');
  $(".get-currncy-symbol").text(getval);
}
$(".custom-btn").click(function() {
    // Get selected values and trim spaces
    var selectedCountry = $('.country-list option:selected').val().trim();
    var selectedLanguage = $('.language-details option:selected').val().trim();

    // Log selected values for debugging
    console.log('Selected Country:', selectedCountry);
    console.log('Selected Language:', selectedLanguage);

    // Handle language selection
    $('select.thb-language-code.cstm-lang option').each(function() {
        var secondLanguage = $(this).val().trim();
        console.log('Checking Language:', secondLanguage);
        
        if (selectedLanguage == secondLanguage) {
            console.log('Language Matched:', secondLanguage);
            $(this).prop('selected', true);
            // Dispatch native change event
            var changeEvent = new Event('change', { bubbles: true });
            $(this).closest('select')[0].dispatchEvent(changeEvent);
        }
    });

    // Handle currency selection
     $('select.thb-currency-code.cstm-currncy option').each(function() {
         var optionValue = $(this).val().trim();
         console.log('Checking currency option:', optionValue);

         if (optionValue.includes(selectedCountry)) {
             console.log('Matched currency option:', optionValue);
             $(this).prop('selected', true);
            // Dispatch native change event
             var changeEvent = new Event('change', { bubbles: true });
           $(this).closest('select')[0].dispatchEvent(changeEvent);
             return false; // Exit loop after first match
         }
     });
});
  $('#countryy').click(function(){
    $('body').addClass("ship-drawer");
  });
  $('#close-drwr').click(function(){
    $('body').removeClass("ship-drawer");
  });
  })

  function updateCurrencySymbol() {
    const select = document.querySelector('.country-list');
    const symbolSpan = document.querySelector('.get-currncy-symbol');
    const selectedOption = select.options[select.selectedIndex];
    const symbol = selectedOption.getAttribute('getsymbol');
    symbolSpan.textContent = symbol;
  }

  // Run on page load
  window.onload = updateCurrencySymbol;

// add class for sticky cart 
      document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.getElementById("AddToCart");

  if (!addToCartBtn) return;

  // Add class conditionally
  addToCartBtn.classList.add("sticky-cart-mobile");

  // Example: add when sticky bar is visible
  const stickyElement = document.querySelector("product-add-to-cart-sticky");
  if (stickyElement) {
    const observer = new MutationObserver(() => {
      if (stickyElement.classList.contains("sticky--visible")) {
        addToCartBtn.classList.add("sticky-cart-mobile");
      } else {
        addToCartBtn.classList.remove("sticky-cart-mobile");
      }
    });
    observer.observe(stickyElement, { attributes: true, attributeFilter: ["class"] });
  }
});
